import { Size } from '@sgme/ui';
import classNames from 'classnames';
import type { ChangeEvent, ReactNode } from 'react';
import { forwardRef, useCallback } from 'react';

export interface CheckboxProps {
  checked: boolean;
  disabled?: boolean;
  edited?: boolean;
  onChange?: (checked: boolean) => void;
  className?: string;
  id?: string;
  e2e?: string;
  size?: Size;
  label?: string | ReactNode;
  labelClassName?: string;
}

export const Checkbox = forwardRef<HTMLInputElement, CheckboxProps>(
  ({ id, checked, disabled, edited, onChange, className, e2e, size = 'md', label, labelClassName }, ref) => {
    const checkBoxId = id ?? e2e ?? 'checkbox-id';
    const e2eCheckbox = e2e ?? `checkbox-${checkBoxId}`;
    const e2eCheckboxLabel = `${e2eCheckbox}-label`;

    const handleOnChange = useCallback(
      (e: ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        const val = e.target.checked;
        if (!disabled) {
          onChange?.(val);
        }
      },
      [onChange, disabled],
    );

    return (
      <div className={classNames(className, `form-check form-check-inline form-check-${size} m-0`)}>
        <input
          ref={ref}
          id={id}
          name={id}
          data-e2e={e2eCheckbox}
          className={classNames('form-check-input', {
            'is-edited': edited,
          })}
          checked={checked}
          disabled={disabled}
          onChange={handleOnChange}
          type="checkbox"
        />
        <label
          className={classNames('form-check-label user-select-none', labelClassName)}
          htmlFor={id}
          data-e2e={e2eCheckboxLabel}
        >
          {label}
        </label>
      </div>
    );
  },
);
